module.exports = __webpack_public_path__ + "img/android_en.d5a9b595.jpg";